export enum ClusterOfficeAppType {
  Document = 'document',
  Spreadsheet = 'spreadsheet',
  Slide = 'slide',
  Pdf = 'pdf'
}
